/* Parcel querying services against live EcoNinhursag API. */

import { request } from './http'

export interface ParcelItem {
  parcel_id: number
  observation_date: string
  season: string
  zone: string
  polygon_geojson?: {
    type: string
    coordinates: number[][][]
  }
  label?: {
    crop: string
    irrigation: string
  }
  features?: Array<{
    feature_name: string
    feature_value: number
  }>
  context?: Array<{
    context_name: string
    context_value: string
  }>
}

export interface ParcelListResponse {
  items: ParcelItem[]
  total: number
  page: number
  page_size: number
  pages: number
}

export function fetchParcels(params: {
  page?: number
  pageSize?: number
  season?: string
  zone?: string
} = {}): Promise<ParcelListResponse> {
  return request<ParcelListResponse>('/parcels', {
    query: {
      page: params.page ?? 1,
      page_size: params.pageSize ?? 50,
      season: params.season,
      zone: params.zone,
    },
  })
}

export function fetchParcelDetail(id: number, signal?: AbortSignal): Promise<ParcelItem> {
  return request<ParcelItem>(`/parcels/${id}`, { signal })
}
